import { Launch } from "@models/launch.model";
import { AudienceDefinition } from "@models/audienceDefinition.model";
import { engagementStore } from "./engagementStore";
import { launchActions } from "./launchStore";
import { engagementContentStore } from "./components/phases/content/engagementContentStore";
import { publishActions, publishStore } from "./components/phases/publish/publishStore";
import { audienceBuilderStore } from "./components/phases/audience/audienceBuilderStore";

/*
    Every store below holds a selection or a cached payload belonging to one
    engagement, but they are module singletons — nothing about them is keyed to
    an engagement id. Left alone, opening a second engagement inherits the
    first one's campaign, audiences, ad selection and network view, which reads
    as a step that "remembers" a record it was never shown.

    One owner clears the lot when the engagement changes: EngagementDetailPage.
    Same shape as resetEngagementContractStore, which the contract item already
    calls for its own store.
*/
export function resetEngagementScopedState() {
  // Also clears the launch's audiences and network configs.
  launchActions.setCurrentLaunch(null);
  launchActions.setCurrentObjective(null);

  engagementStore.selectedLaunch = new Launch();
  engagementStore.selectedAudience = new AudienceDefinition();
  engagementStore.networkViewCache = null;
  engagementStore.networkViewCacheDate = null;

  engagementContentStore.selectedAdId = -1;
  engagementContentStore.selectedTodoId = -1;
  engagementContentStore.selectedAudienceId = -1;

  // Also clears the placement assignments, ad selection and open popover.
  publishActions.setSelectedAudience(null);
  publishStore.visibleNetworks = [];
  publishStore.adSearchQuery = "";

  audienceBuilderStore.previewCount = null;
}
